import { createContext, useContext, useState } from 'react';
import {
  buildRange,
  dateRangeFromDateTimes,
  datetimeLocalToIso,
  defaultCustomDateTimeRange,
  isValidCustomDateTimeRange,
} from '../../utils/dateRange';

const RANGE_PRESETS = {
  '7d': 7,
  '28d': 28,
  '90d': 90,
};

const DateRangeContext = createContext(null);

export function DateRangeProvider({ children }) {
  const [preset, setPreset] = useState('28d');
  const [customFrom, setCustomFrom] = useState(() => defaultCustomDateTimeRange().from);
  const [customTo, setCustomTo] = useState(() => defaultCustomDateTimeRange().to);
  const customValid = preset === 'custom' && isValidCustomDateTimeRange(customFrom, customTo);
  const customDates = customValid ? dateRangeFromDateTimes(customFrom, customTo) : null;
  const range = customDates || buildRange(RANGE_PRESETS[preset] || 28);
  const visitRange = customValid
    ? { from: datetimeLocalToIso(customFrom), to: datetimeLocalToIso(customTo) }
    : range;

  return (
    <DateRangeContext.Provider
      value={{
        preset,
        setPreset,
        range,
        visitRange,
        customFrom,
        customTo,
        setCustomFrom,
        setCustomTo,
      }}
    >
      {children}
    </DateRangeContext.Provider>
  );
}

export function useDateRange() {
  const context = useContext(DateRangeContext);
  if (!context) {
    throw new Error('useDateRange must be used within DateRangeProvider');
  }
  return context;
}

const DATE_RANGE_PRESETS = [...Object.keys(RANGE_PRESETS), 'custom'];

export function RangeSelect({ id }) {
  const { preset, setPreset, customFrom, customTo, setCustomFrom, setCustomTo } = useDateRange();

  return (
    <div className="range-controls">
      <label htmlFor={id} className="range-label">
        Range
      </label>
      <select id={id} value={preset} onChange={(event) => setPreset(event.target.value)}>
        {DATE_RANGE_PRESETS.map((option) => (
          <option key={option} value={option}>
            {option === 'custom' ? 'Custom' : `Last ${option}`}
          </option>
        ))}
      </select>
      {preset === 'custom' ? (
        <div className="range-custom">
          <label>
            From
            <input
              type="datetime-local"
              value={customFrom}
              onChange={(event) => setCustomFrom(event.target.value)}
            />
          </label>
          <label>
            To
            <input
              type="datetime-local"
              value={customTo}
              onChange={(event) => setCustomTo(event.target.value)}
            />
          </label>
        </div>
      ) : null}
    </div>
  );
}
